import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function inventoryFullCategoryTreeReducer(
  state = initialState.inventoryFullCategoryTree,
  action,
) {
  const { data, type } = action;
  switch (type) {
    case actionTypes.GET_FULL_CATEGORY_TREE_SUCCESS: {
      return data;
    }
    default: {
      return state;
    }
  }
}
